import { CommonModule, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/id';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ForceNumberDirective } from '@merchant-portal/app/directives/force-number.directive';
import {
  IWithdrawalPrepareResponse,
  WithdrawalDestinationSelectOption,
} from '@merchant-portal/app/models/payment/payment.interface';
import { NgxCurrencyDirective } from 'ngx-currency';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ToastModule } from 'primeng/toast';
import { SvgLoaderModule } from '../../../../../components/icon/svg-loader/svg-loader/svg-loader.module';
import { DefaultValuePipe } from '../../../../../pipe/default-value.pipe';
import {
  walletWithdrawalDestinations,
  withdrawalDestinations,
  withdrawalDestinationType,
} from '../constant/withdrawal-destination.constant';
registerLocaleData(localeFr, 'id');

@Component({
  selector: 'app-withdrawal-request-component-dialog',
  templateUrl: './withdrawal-request.component-dialog.html',
  styleUrls: ['./withdrawal-request.component-dialog.scss'],
  imports: [
    CommonModule,
    CardModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputTextModule,
    ButtonModule,
    DialogModule,
    ToastModule,
    FormsModule,
    SvgLoaderModule,
    NgxCurrencyDirective,
    ForceNumberDirective,
    DefaultValuePipe,
    SelectModule,
  ],
})
export class WithdrawalRequestDialogComponent {
  amount: number | null = null;
  minAmount: number = 10000;
  showTooltip = false;
  content: IWithdrawalPrepareResponse['data'];
  destinations: WithdrawalDestinationSelectOption[] = [];
  destination: WithdrawalDestinationSelectOption | null = null;

  constructor(
    private ref: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig
  ) {
    this.content = this.dialogConfig.data.data;
    if (this.content.isVcc) {
      this.destination = {
        name: 'Bank Account',
        code: withdrawalDestinationType.BANK_TRANSFER,
      };
    } else if (this.content.isWallet) {
      this.destinations = walletWithdrawalDestinations.map(opt =>
          opt.code === withdrawalDestinationType.BANK_TRANSFER
            ? { ...opt, disabled: false } // enable only for default selection
            : opt
        );
      this.destination =
        this.destinations.find(item => item.code === withdrawalDestinationType.BANK_TRANSFER) ?? null;
    } else {
      this.destinations = withdrawalDestinations;
      this.destination =
        this.destinations.find(item => item.code === withdrawalDestinationType.BANK_TRANSFER) ?? null;
    }

    setTimeout(() => {
      if (this.content.isWallet) {
        const item = this.destinations.find(
          opt => opt.code === withdrawalDestinationType.BANK_TRANSFER
        );
        if (item) item.disabled = true; // reset the disabled state
      }
    }, 0);
  }

  confirm() {
    this.ref.close({
      amount: this.amount,
      destination: this.destination,
    });
  }

  cancel() {
    this.ref.close();
  }

  isAllowWithdrawal(): boolean {
    const isAmountMoreThanMinimum = this.amount !== null && this.amount >= this.minAmount;
    const isDestinationSelected = this.destination !== null;
    const isBankAvailable =
      (this.destination?.code === withdrawalDestinationType.BANK_TRANSFER &&
        this.content.bankAccounts &&
        this.content.bankAccounts.length > 0) ||
      this.destination?.code !== withdrawalDestinationType.BANK_TRANSFER;

    return isAmountMoreThanMinimum && isDestinationSelected && isBankAvailable;
  }
}
